import {
  GamePass,
  getEntitlements,
  EntitlementKind,
  EntitlementStatus,
} from "@blacknut/javascript-sdk/dist";
import { t } from "i18next";
import { firstValueFrom } from "rxjs";
import React, { useCallback } from "react";
import { HeaderElementModal } from "src/components/Modals/HeaderElementModal";
import { ModalSubscription, useModal } from "@blacknut/react-sdk";
import { useRef } from "react";
import styles from "./styles.module.scss";
import { logE } from "@blacknut/logging/dist";
import { LOGGING_TAG } from "../Utils";

export const useUbisoftPremium = () => {
  const { push: modalPush } = useModal();
  const modalSubscription = useRef<ModalSubscription>();
  const closeModal = useCallback(() => {
    modalSubscription.current?.remove();
    modalSubscription.current = undefined;
  }, []);

  // Verifies that the user doesn't already have Ubisoft entitlement
  // *In theory* this only happens when upgrading from Ubisoft+ Classics to Premium
  const checkForUbisoftPremiumUpgrade = async (isUbi?: boolean, gamePass?: GamePass) => {
    if (!isUbi || !gamePass) {
      return true;
    }
    try {
      const entitlements = await firstValueFrom(getEntitlements());
      const activeUbisoftEntitlements = entitlements.filter(
        (e) =>
          e.kind === EntitlementKind.UBISOFT_PLUS &&
          e.status === EntitlementStatus.ACTIVE,
      );

      if (activeUbisoftEntitlements.length > 0) {
        const background = gamePass.images.find((im) => im.kind === "background");
        const logo = gamePass.images.find((im) => im.kind === "logo");
        modalSubscription.current = modalPush((props) => (
          <HeaderElementModal
            {...props}
            title={t("subscription.passSubscriptions.subscribe.ubisoftpremiumsoon")}
            description={t("subscription.passSubscriptions.subscribe.ubisoftpremium")}
            onClose={closeModal}
            positiveButtonText={t("buttons.ok")}
            onPressPositive={closeModal}
            headerElement={
              <div className={styles.background}>
                <img className={styles.logo} src={logo?.url} />
                <img className={styles.background} src={background?.url} />
              </div>
            }
          />
        ));

        return false;
      }
    } catch (e) {
      logE(LOGGING_TAG, "Caught error getting entitlements");
    }

    return true;
  };

  return { checkForUbisoftPremiumUpgrade };
};
